import styled from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
    margin: 8px 0px; 
    width: 100%
`;

export default Wrapper(template);
